import { DEFAULT_LOCALE } from "./locales";
import { useCallback } from "react";
import { useLocale } from "./LocaleProvider";

function lookup(bundle, key) {
  return key
    .split(".")
    .reduce(
      (acc, part) => (acc && typeof acc === "object" ? acc[part] : undefined),
      bundle
    );
}

function format(template, vars) {
  if (!vars || typeof template !== "string") return template;
  return template.replace(/\{\{(\w+)\}\}/g, (_, name) =>
    Object.prototype.hasOwnProperty.call(vars, name)
      ? String(vars[name])
      : `{{${name}}}`
  );
}

export function useT() {
  const { lang, bundles } = useLocale();
  return useCallback(
    (key, vars) => {
      const primary = lookup(bundles[lang], key);
      if (typeof primary === "string") return format(primary, vars);
      const fallback = lookup(bundles[DEFAULT_LOCALE], key);
      if (typeof fallback === "string") return format(fallback, vars);
      return key;
    },
    [lang, bundles]
  );
}

export function useLocaleData(path) {
  const { lang, bundles } = useLocale();
  const localized = lookup(bundles[lang], path);
  if (localized !== undefined) return localized;
  return lookup(bundles[DEFAULT_LOCALE], path);
}
